import { render } from "./TransferableSkillsView.vue?vue&type=template&id=635dff6c"
import script from "./TransferableSkillsView.vue?vue&type=script&lang=js"
export * from "./TransferableSkillsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__